import { useTranslation } from "react-i18next";
import { DraftCard } from "../DraftCard";
import { useDraftContext } from "../DraftContext";
import type { EntityDraftCardProps } from "../registry";
import { AgentDraftSummary } from "./AgentDraftSummary";
import { useAgentDraft } from "./useAgentDraft";

/** An agent draft: Create (with the user's team, linked to this chat) or Save an existing agent. */
export function AgentDraftCard({ draft, state, entityUuid, updatedAt, answerable }: Readonly<EntityDraftCardProps>) {
  const { t } = useTranslation("buildChat", { keyPrefix: "draft" });
  const { linked } = useDraftContext();
  const agent = useAgentDraft(draft);
  const target = linked.find((e) => e.uuid === draft.targetUuid);
  return (
    <DraftCard
      title={agent.body.name ?? target?.name ?? t("untitled")}
      entityLabel={t("entity.agent")}
      state={state}
      isUpdate={Boolean(draft.targetUuid)}
      doneUuid={agent.doneUuid}
      entityUuid={entityUuid}
      updatedAt={updatedAt}
      summary={<AgentDraftSummary body={agent.body} skillUuids={agent.skillUuids} />}
      missingFields={draft.missingFields}
      questions={draft.questions}
      answerable={answerable}
      busy={agent.busy}
      steps={agent.steps}
      blocked={agent.blocked}
      onCreate={agent.run}
      onRetry={agent.retry}
      onOpenInForm={agent.openInForm}
      detailPath={(uuid) => `/build/agents/${uuid}`}
    />
  );
}
